import { useInView } from "react-intersection-observer";
import { css } from "@emotion/react";

// services and events
import Header from "organisms/Header";
import Footer from "organisms/Footer";
import RunYourD2CBusiness from "organisms/HomePageWidgets/RunYourD2CBusiness";
import TrustedByBrands from "organisms/HomePageWidgets/TrustedByBrands";
import WeHelpYouSucceed from "organisms/HomePageWidgets/WeHelpYouSucceed";
import OurOfferings from "organisms/HomePageWidgets/OurOfferings";
import Founders from "organisms/HomePageWidgets/Founders";
import GrowthConsulting from "organisms/HomePageWidgets/GrowthConsulting";
import Pricing from "organisms/HomePageWidgets/Pricing";
import Testimonial from "organisms/HomePageWidgets/Testimonial";
import YourJourney from "organisms/HomePageWidgets/YourJourney";
import BookDemoForm from "organisms/HomePageWidgets/BookDemoForm";
import ResponsiveDiv from "atoms/ResponsiveDiv";
import HashLink from "atoms/HashLink";
import Button from "atoms/Button";

const styles = {
	bookDemoBtnInitialStyle: css`
		opacity: 0;
		transform: translateY(50px); /* Start further down for a smoother effect */
		transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
		position: fixed;
		bottom: 23px;
		right: 13px;
		z-index: 1000;
  `,
	nonViewModeBookDemoStyle: css`
	  opacity: 1 !important;
    transform: translateY(0);
  `,
}

export default () => {

	const { ref: formSectionRef, inView: isFormSectionInView, entry: formSectionEntry } = useInView({
		triggerOnce: false,
		threshold: 0,
		rootMargin: '-50px 0% 0% 0%'
	});

	return (
		<>
			<Header hideNavbarlinks={true} demoButtonVisibility={"none"} />
			<div ref={formSectionRef}>
				<BookDemoForm />
			</div>
			<RunYourD2CBusiness bookDemoUrl="/#demo-form" showBookFormCTA={false} />
			<TrustedByBrands />
			<WeHelpYouSucceed />
			<OurOfferings />
			<GrowthConsulting />
			<Testimonial />
			<Pricing />
			<YourJourney />
			<Founders />
			<ResponsiveDiv css={css`
					${styles.bookDemoBtnInitialStyle};
					${!isFormSectionInView && formSectionEntry && styles.nonViewModeBookDemoStyle};
					`}>
				<HashLink to={"/book-demo-form#demo-form"}>
					<Button type="primary">Book a Free Demo</Button>
				</HashLink>
			</ResponsiveDiv>
			<Footer hideNavbarlinks={true} />
		</>
	);
};
